import Vue from "vue";
import { AuthorizationData } from "@/features/Authentication/PlatformUserInfoService";
import { ListAction } from "@/features/Actions/Action";

export class ActionAuthorizationService {
    private authData: AuthorizationData;

    constructor() {
        this.authData = Vue.prototype.$platformUserInfoService.getUserAuthorizationData();
    }

    canCreateAction(): boolean {
        // For now, we are implicitly treating all actions on compliance as Incident actions;
        // this check is specifically based on requirements for Incidents and may need to change for other action types
        return this.authData.allSuppliersVisible == true;
    }

    canEditAction(action: ListAction): boolean {
        return action.createdByUserID == this.authData.userID;
    }

    canDeleteAction(action: ListAction): boolean {
        return action.createdByUserID == this.authData.userID;
    }

    canAcknowledgeAction(action: ListAction): boolean {
        return action.users.some(u => u.id == this.authData.userID);
    }

    canCompleteAction(action: ListAction): boolean {
        return action.users.some(u => u.id == this.authData.userID);
    }
}
